export const eventKey = (environment: string, service: string, day: string) => [environment, service, day].join('/')
